import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import {
  Dashboard as DashboardIcon,
  Person as PersonIcon,
  NotificationsNone as NotificationsNoneIcon,
  TableChart as TableChartIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { toast } from "react-toastify";
import "./Sidebar.scss";
import { removeAdminToken } from "../../../utils/auth";

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = React.useState(null);

  const handleLogout = async () => {
    try {
      // Remove admin authentication token
      await removeAdminToken();

      // Clear storage
      localStorage.clear();
      sessionStorage.clear();

      // Navigate to admin login page & prevent back navigation
      navigate("/admin/login", { replace: true });

      // Optional: Force a reload to ensure a fresh state
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };


  const toggleDropdown = (menu) => {
    setOpenDropdown((prev) => (prev === menu ? null : menu));
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div className="logo">
        <Link to="/admin/dashboard" className="text_none">
          <img src="/LOGOS/Farmology-Logo-e1687720251448.png" alt="Logo" />
        </Link>
      </div>
      <div className="links">
        <ul>
          <p className="spann">Main</p>
          <Link to="/admin/dashboard" className="text_none">
            <li className={isActive("/admin/dashboard") ? "active" : ""}>
              <DashboardIcon className="icon" /> Dashboard
            </li>
          </Link>

          <p className="spann">Lists</p>
          <Link to="/admin/all-admins" className="text_none">
            <li className={isActive("/admin/all-admins") ? "active" : ""}>
              <PersonIcon className="icon" /> Admins
            </li>
          </Link>

          <li
            className={openDropdown === "notifications" ? "active" : ""}
            onClick={() => toggleDropdown("notifications")}
          >
            <FontAwesomeIcon icon={faBell} className="icon" /> Notifications
          </li>
          {openDropdown === "notifications" && (
            <ul className="dropdown">
              <Link to="/admin/push-notification" className="text_none">
                <li
                  className={
                    isActive("/admin/push-notification") ? "active" : ""
                  }
                >
                  <NotificationsNoneIcon className="icon" /> Push Notification
                </li>
              </Link>
              <Link to="/admin/schedule-notification" className="text_none">
                <li
                  className={
                    isActive("/admin/schedule-notification") ? "active" : ""
                  }
                >
                  <NotificationsNoneIcon className="icon" /> Schedule
                  Notification
                </li>
              </Link>
              <Link to="/admin/weather-notification" className="text_none">
                <li
                  className={
                    isActive("/admin/weather-notification") ? "active" : ""
                  }
                >
                  <NotificationsNoneIcon className="icon" /> Weather
                  Notification
                </li>
              </Link>
            </ul>
          )}

          <Link to="/admin/product-recommendation" className="text_none">
            <li
              className={
                isActive("/admin/product-recommendation") ? "active" : ""
              }
            >
              <TableChartIcon className="icon" /> Recommended Products
            </li>
          </Link>
          <Link to="/admin/crop-stage" className="text_none">
            <li className={isActive("/admin/crop-stage") ? "active" : ""}>
              <NotificationsNoneIcon className="icon" /> Crop Stage
            </li>
          </Link>

          <p className="spann">Settings</p>
          <li onClick={handleLogout} style={{ cursor: "pointer" }}>
            <LogoutIcon className="icon" /> Log Out
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
